var plugin_default = {
  "alignLeft": "fOukU",
  "textWrapNowrap": "VTGvR",
  "alignRight": "Qd61P",
  "alignCenter": "kFYln",
  "sizeFullWidth": "avI9p",
  "renderedInTable": "KpnAH",
  "sizeOriginal": "chiuh",
  "sizeContent": "kNp4J",
  "sizeSmall": "VHjWV",
  "sizeSmallCenter": "eNlDq",
  "flex": "n25iR",
  "atomic": "xziK1",
  "embed": "Ibkbl",
  "horizontalScrollbar": "O5xNh",
  "pluginContainerMobile": "d4U3N"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
